export default "__VITE_ASSET__BdefwBM0__"